import  { useState } from 'react';

const Checkout = () => {
  const [shippingDetails, setShippingDetails] = useState({
    fullName: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
  });

  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: '',
    expirationDate: '',
    cvv: '',
  });

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Shipping Details:', shippingDetails);
    console.log('Payment Details:', paymentDetails);
  };

  return (
    <div className="bg-gray-100 dark:bg-gray-900 min-h-screen p-6">
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Checkout</h1>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Shipping Details */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Shipping Details</h2>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={shippingDetails.fullName}
                  onChange={handleShippingChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="John Doe"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">Address</label>
                <input
                  type="text"
                  name="address"
                  value={shippingDetails.address}
                  onChange={handleShippingChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="123 Main St"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">City</label>
                <input
                  type="text"
                  name="city"
                  value={shippingDetails.city}
                  onChange={handleShippingChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="New York"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">State</label>
                <input
                  type="text"
                  name="state"
                  value={shippingDetails.state}
                  onChange={handleShippingChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="NY"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">Zip Code</label>
                <input
                  type="text"
                  name="zipCode"
                  value={shippingDetails.zipCode}
                  onChange={handleShippingChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="10001"
                />
              </div>
            </div>
            {/* Payment Information */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Payment Information</h2>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">Card Number</label>
                <input
                  type="text"
                  name="cardNumber"
                  value={paymentDetails.cardNumber}
                  onChange={handlePaymentChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="1234 5678 9012 3456"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">Expiration Date</label>
                <input
                  type="text"
                  name="expirationDate"
                  value={paymentDetails.expirationDate}
                  onChange={handlePaymentChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="MM/YY"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 dark:text-gray-300">CVV</label>
                <input
                  type="text"
                  name="cvv"
                  value={paymentDetails.cvv}
                  onChange={handlePaymentChange}
                  className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md focus:border-red-600 focus:outline-none bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="123"
                />
              </div>
            </div>
          </div>
          {/* Order Summary */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg mt-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Order Summary</h2>
            <div className="mb-4">
              <div className="flex justify-between text-gray-900 dark:text-white">
                <span>Product 1</span>
                <span>€50.00</span>
              </div>
              <div className="flex justify-between text-gray-900 dark:text-white">
                <span>Product 2</span>
                <span>€30.00</span>
              </div>
              <div className="flex justify-between text-gray-900 dark:text-white">
                <span>Shipping</span>
                <span>€5.00</span>
              </div>
            </div>
            <div className="flex justify-between font-bold text-lg text-gray-900 dark:text-white">
              <span>Total</span>
              <span>€85.00</span>
            </div>
          </div>
          {/* Complete Purchase Button */}
          <div className="mt-6 text-right">
            <button type="submit" className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-500">
              jetz kaufen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Checkout;